var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEyeLinedOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.469673 0.46967C0.762566 0.176777 1.23744 0.176777 1.53033 0.46967L29.5303 28.4697C29.8232 28.7626 29.8232 29.2374 29.5303 29.5303C29.2374 29.8232 28.7626 29.8232 28.4697 29.5303L0.469673 1.53033C0.17678 1.23744 0.17678 0.762563 0.469673 0.46967Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.163 12.3798C13.4735 12.6539 13.5031 13.1278 13.229 13.4384C12.8612 13.8551 12.6389 14.4006 12.6389 15C12.6389 16.304 13.696 17.3611 15 17.3611C15.5993 17.3611 16.1449 17.1388 16.5616 16.771C16.8721 16.4969 17.3461 16.5264 17.6202 16.837C17.8943 17.1475 17.8647 17.6215 17.5542 17.8956C16.874 18.4959 15.9787 18.8611 15 18.8611C12.8676 18.8611 11.1389 17.1324 11.1389 15C11.1389 14.0212 11.504 13.126 12.1044 12.4458C12.3785 12.1352 12.8524 12.1057 13.163 12.3798Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3993 7.66462C8.63702 8.00383 8.55473 8.47152 8.21552 8.70924C5.84116 10.3731 3.82159 12.7185 1.92564 15.0493C3.32543 17.1544 5.20509 19.2284 7.37365 20.8048C9.698 22.4944 12.3122 23.5834 15 23.5834C17.2403 23.5834 19.4293 22.8274 21.4452 21.5947C21.7986 21.3786 22.2602 21.4899 22.4763 21.8433C22.6924 22.1967 22.5811 22.6583 22.2277 22.8744C20.039 24.2128 17.5817 25.0834 15 25.0834C11.9038 25.0834 8.98686 23.8319 6.49166 22.0181C3.99498 20.2032 1.87839 17.7959 0.365841 15.4005C0.194331 15.1288 0.214854 14.7781 0.416877 14.5284C2.40019 12.0764 4.6402 9.38308 7.35469 7.48083C7.6939 7.24312 8.16159 7.32541 8.3993 7.66462Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 5.66666C14.25 5.25245 14.5858 4.91666 15 4.91666C21.647 4.91666 26.0516 10.1621 29.5831 14.5283C29.7851 14.7781 29.8056 15.1288 29.6341 15.4004C29.1229 16.2101 28.5437 17.0195 27.9055 17.8059C27.6444 18.1276 27.1721 18.1767 26.8505 17.9157C26.5289 17.6547 26.4797 17.1823 26.7407 16.8607C27.2231 16.2663 27.6691 15.6586 28.0743 15.0493C24.5457 10.7132 20.6404 6.41666 15 6.41666C14.5858 6.41666 14.25 6.08088 14.25 5.66666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeLinedOff);
export default __webpack_public_path__ + "static/media/ic_eye_lined_off.a597bf23fe98be0734883e54f673d35a.svg";
export { ForwardRef as ReactComponent };